<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12 ">
                <div class="card">
                    <Toolbar>
                        <template #left>
                        </template>
                    </Toolbar>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <DataTable ref="dt" :value="datatable.data" sortField="id" :sortOrder="0" :lazy="true" data-key="id" :paginator="true" :rows="10" :loading="datatable.loading" :total-records="datatable.totalRecords" filter-display="menu" :global-filter-fields="datatable.globalFilterFields" v-model:filters="datatable.filters" paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rows-per-page-options="[5, 10, 25]" current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data" @page="onPage($event)" @sort="onSort($event)" @filter="onFilter()">
                        <template #header>
                            <div class="table-header">
                                <h5 class="p-m-0 text-center">
                                    Daftar Paket Pengadaan (Paket)
                                </h5>
                                <div class="flex justify-content-between">
                                    <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined" @click="clearFilter()" />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="datatable.filters['global'].value" @input="onFilter()" @keydown.enter="onFilter()" placeholder="Keyword Search" />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="id_proposal_urp" header="ID Proposal URP" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.id_proposal_urp }}
                            </template>
                        </Column>
                        <Column field="nama_paket_pengadaan" header="Nama Paket" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.nama_paket_pengadaan }}
                            </template>
                        </Column>
                        <Column field="pagu_anggaran" header="Pagu Anggaran" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.pagu_anggaran }}
                            </template>
                        </Column>
                        <Column field="nama_metode_pemilihan" header="Metode Pemilihan" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.nama_metode_pemilihan }}
                            </template>
                        </Column>
                        <Column field="unit" header="Unit" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.unit }}
                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 150px;">
                            <template #body="slotProps">
                                <Button icon="pi pi-plus" class="p-button-info p-button-sm mr-1"
                                    @click="create(slotProps.data.id)" >
                                </Button>
                                <Button v-if="isAuthorized" icon="pi pi-trash" class="p-button-sm p-button-danger"
                                    @click="showDeleteDialog(slotProps.data)" />
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <DeleteDialog ref="deleteDialog" v-model:visible="deleteDialog" :loading="deletingModel" @delete="onDelete" />
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DeleteDialog from "../../Components/DeleteDialog";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText
    },
    data() {
        return {
            datatable: {
                loading: true,
                totalRecords: 0,
                data: null,
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    // 'status': { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                globalFilterFields: ['id_proposal_urp', 'nama_paket_pengadaan', 'pagu_anggaran', 'nama_metode_pemilihan', 'unit'],
                lazyParams: {}
            },
            menuItems: [
                {
                    label: 'Tambah Organisasi Pengadaan',
                    icon: 'pi pi-fw pi-plus',
                    class: 'p-button-primary p-button-raised',
                    command: () => {
                        this.$inertia.get(this.route('organisasi_pengadaan.create'));
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            isAuthorized: false,
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields
        };
        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.datatable.loading = true;
            this.datatableService.getData(this.route('organisasi_pengadaan.datatable_paket_pengadaan'), {
                dt_params: JSON.stringify(this.datatable.lazyParams),
                searchable_columns: JSON.stringify(this.datatable.globalFilterFields)
            }).then(data => {
                this.datatable.data = data.payload.data;
                this.datatable.totalRecords = data.payload.total;
                this.datatable.loading = false;
            }).catch(error => {
                console.error('Error loading data:', error);
                this.datatable.data = [];
                this.datatable.totalRecords = 0;
                this.datatable.loading = false;
            });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.datatable.lazyParams.first = 0; // Reset to first page when filtering
            this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters = {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
            };
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.datatable.lazyParams.first = 0; // Reset to first page when clearing filter
            this.loadLazyData();
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            //  console.log(this.datatable.lazyParams);
            // this.loadLazyData();
        },
        onSort(event) {
            // console.log(event);
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // this.loadLazyData();
        },
        create(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.buat', id), { preserveScroll: true });
        },
        edit(id) {
            this.$inertia.visit(this.route('organisasi_pengadaan.edit', id), { preserveScroll: true });
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete() {
            this.deletingModel = true;
            this.$inertia.delete(this.route('organisasi_pengadaan.destroy', this.selectedModel.id), {
                onSuccess: () => {
                    this.deletingModel = false;
                    this.deleteDialog = false;
                    this.loadLazyData();
                    this.$refs.deleteDialog.onClose();
                }
            })
        },
    }
}
</script>

<style scoped></style>
